import { useQuery } from '@apollo/client';
import { GET_WAITLIST_ENTRIES } from '../lib/graphqlOperations.js';

export function useWaitlistCount() {
  const { data: customerData } = useQuery(GET_WAITLIST_ENTRIES, {
    variables: { entryType: "customer", limit: 10000, skip: 0 },
    pollInterval: 10000,
  });
  // console.log(customerData)

  const { data: vendorData } = useQuery(GET_WAITLIST_ENTRIES, {
    variables: { entryType: "vendor", limit: 10000, skip: 0 },
    pollInterval: 10000,
  });

  return {
    counts: {
      customer: customerData?.getWaitlistEntries?.totalCount || 0,
      vendor: vendorData?.getWaitlistEntries?.totalCount || 0,
    },
  };
}
